import type { FaireProductEntity } from "../../entity_types/product";

export const p_pebd9n87re: FaireProductEntity = {
  token: "p_pebd9n87re",
  type: "product",
  name: "SLOW RISE GAMER TOY  24/BAG",
  brandToken: "b_9viz2xeqrn",
  brandName: "Geddes",
  imageUrl:
    "https://cdn.faire.com/fastly/a6551aabed5dc6d0be0fd7a1795af9236c99e9b23f2b14b9e20ce4d697c6d606.jpeg",
  galleryImageUrls: [],
  priceDollars: 0.94,
  description:
    "Slow Rise Gamer Squishy Toy - 72472\nStress relieving toy looks just like a game controller. Colors: orange, blue, and green. 3” x 2.5” in size. 24/Bag.",
  tags: [],
  msrpDollars: 1.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:30.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
